import Vue from 'vue'
import App from './App.vue'
import store from './store'
import * as SocialSharing from 'vue-social-sharing'
import { firebaseAuth, firebaseMessaging } from './utils/firebase'
import EvaIcons from 'vue-eva-icons'
import { register } from 'register-service-worker'
import PortalVue from 'portal-vue'
import { Plugin } from 'vue-fragment'

import Framework7 from 'framework7/framework7.esm.bundle.js'

import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'

import VCalendar from 'v-calendar'

// Import F7 Styles
import './css/framework7.bundle.min.css'
import 'vue-tel-input/dist/vue-tel-input.css'

// Import Icons and App Custom Styles
import './css/app.scss'

import Preloader from 'framework7/components/preloader/preloader.js' // access/inbox.vue

import { extend, localize, setInteractionMode } from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'
import { required, email, regex, image, numeric, min } from 'vee-validate/dist/rules'

extend('email', email)
extend('min', min)
extend('regex', regex)
extend('image', image)
extend('numeric', numeric)
extend('required', required)
localize('es', es)
setInteractionMode('eager')

Framework7.use([Framework7Vue, Preloader])
Vue.use(PortalVue)
Vue.use(Plugin)
Vue.use(EvaIcons)
Vue.use(SocialSharing)
Vue.use(VCalendar, {
  componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
})
Vue.config.productionTip = false
let vueInstance = null

// Wait for cordova
if (location.hash !== '') {
  // const os = location.hash.slice(1, location.hash.length).split('/')[0]
  // const version = location.hash.slice(1, location.hash.length).split('/')[1]
  // if (os === 'android' || os === 'ios') {
  //   store.commit('settings/setCordovaInfo', { version, os })
  //   const system = `${os}/${version}/cordova.js`
  //   const cordovaScript = document.createElement('script')
  //   cordovaScript.setAttribute('src', system)
  //   cordovaScript.setAttribute('type', 'text/javascript')
  //   document.getElementsByTagName('head')[0].appendChild(cordovaScript)
  //   document.addEventListener('deviceready', () => {
  //     if (typeof StatusBar !== 'undefined') StatusBar.backgroundColorByHexString('#4654D4')
  //     if (typeof cordova.plugins.Keyboard !== 'undefined' && os === 'ios') {
  //       cordova.plugins.Keyboard.shrinkView(true)
  //       window.addEventListener('keyboardDidShow', function () {
  //         document.activeElement.scrollIntoView({
  //           behavior: 'auto',
  //           block: 'center',
  //           inline: 'center',
  //         })
  //       })
  //     }
  //     checkFirebaseUser()
  //   })
  // }
} else {
  checkFirebaseUser()
}

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready (registration) {
      // store.commit('settings/setServiceWorker')
      firebaseMessaging.useServiceWorker(registration)
      console.info(
        'App is being served from cache by a service worker.'
      )
    },
    registered () {
      console.info('Service worker has been registered.')
    },
    cached () {
      console.info('Content has been cached for offline use.')
    },
    updatefound () {
      console.info('New content is downloading.')
      store.commit('settings/setProp', { prop: 'foundUpdate', val: true })
    },
    updated (registration) {
      console.info('New content is available; please refresh.')
      window.registration = registration
      store.commit('settings/setProp', { prop: 'updateIsReady', val: true })
    },
    offline () {
      console.info('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    },
  })
}

function checkFirebaseUser () {
  if (firebaseAuth.currentUser) {
    const user = firebaseAuth.currentUser
    store.commit('auth/setUser', user)
    store.dispatch('auth/getJWT')
    vueInstance = initVue()
  }
  firebaseAuth.onIdTokenChanged(function (user) {
    if (user !== null) {
      store.commit('auth/setUser', user)
      store.dispatch('auth/getJWT')
    } else {
      if (store.state.auth.uid !== null) store.commit('auth/cleanUID', user)
    }
    if (!vueInstance) vueInstance = initVue()
  })
}

function initVue () {
  return new Vue({
    store,
    render: h => h(App),
  }).$mount('#app')
}
